import React from 'react';
import PublicLayout from '@app/layout/PublicLayout.tsx';
import RegistrationDetail from '@app/pages/public/registration.tsx';
import { useSearchParams } from 'react-router-dom';

const RegistrationPage: React.FC = () => {
  const [searchParams] = useSearchParams();

  const registrationCode = searchParams.get('registrationCode');
  return (
    <PublicLayout languageMenuAfterInfo>
      <RegistrationDetail registrationCode={registrationCode} />
    </PublicLayout>
  );
};

export default RegistrationPage;
